import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from "@elastic/eui";
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Recording/Photoseries/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import PhotoTable from 'components/Web_User_Interface/1440p_Series/Recording/Photoseries/PhotoTable';
import ScheduleTable from 'components/Web_User_Interface/1440p_Series/Recording/Photoseries/ScheduleTable';
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "Aufgaben Menü // Fotoserie",
  "path": "/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Fotoserie/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Snapshots in einem einstellbaren Zeitintervall aufnehmen und in einer Drittanbieter-Software zusammenführen um ein TimeLapse Video zu erstellen. Sie können die Snapshots auch mit einem festen Dateinamen hochladen. Dies wird immer die letzte Datei überschreiben und erlaubt es Ihnen ein Live Bild Ihrer Kamera auf Ihrer Webseite anzuzeigen.",
  "image": "./WebUI_1440p_SearchThumb_Tasks_Photoseries.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Tasks_Photoseries.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title="Aufgaben Menü // Fotoserie" dateChanged="2021-12-12" author="Mike Polinowski" tag="INSTAR IP Camera" description="Snapshots in einem einstellbaren Zeitintervall aufnehmen und in einer Drittanbieter-Software zusammenführen um ein TimeLapse Video zu erstellen. Sie können die Snapshots auch mit einem festen Dateinamen hochladen. Dies wird immer die letzte Datei überschreiben und erlaubt es Ihnen ein Live Bild Ihrer Kamera auf Ihrer Webseite anzuzeigen." image="/images/Search/WebUI_1440p_SearchThumb_Tasks_Photoseries.png" twitter="/images/Search/WebUI_1440p_SearchThumb_Tasks_Photoseries.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Web_User_Interface/1440p_Series/Recording/Photoseries/" locationFR="/fr/Web_User_Interface/1440p_Series/Features/Photoseries/" crumbLabel="Photoseries" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "aufgaben-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#aufgaben-men%C3%BC",
        "aria-label": "aufgaben menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Aufgaben Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "konfigurieren-einer-fotoserie-auf-sd-karte",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#konfigurieren-einer-fotoserie-auf-sd-karte",
        "aria-label": "konfigurieren einer fotoserie auf sd karte permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Konfigurieren einer Fotoserie auf SD-Karte`}</h3>
    <p>{`Snapshots in einem einstellbaren Zeitintervall aufnehmen und in einer Drittanbieter-Software zusammenführen um ein TimeLapse Video zu erstellen. Sie können die Snapshots auch mit einem festen Dateinamen hochladen. Dies wird immer die letzte Datei überschreiben und erlaubt es Ihnen ein Live Bild Ihrer Kamera auf Ihrer Webseite anzuzeigen.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/8882c29582df1429710fa93d7200b513/86a1e/1440p_Settings_Tasks_Photoseries.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.60869565217392%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACq0lEQVQ4y6WTS2/TWABG8yeQKqQmaTNt/AjpK0zaaeJnXGjaOLEdPwpiBgkRaHm0gASitEIsOhukYYsEk3mwgA0sEBsWaDbwu87I100psBk0i6N7bekef9+91zlVVVEUBUVVmZosMttYxb33gpWdIWd2htg3f8e6kTIUo7M9pHv3b9R6i5NjJ1hcWqJerzM2NkahUCA3EsqywvTUD+itdTa29ulfvk+8ucfGtYeEV/YIrzwgGOwSDnbZ2NqjYZxlbnaBpaUmi4vLLCz8SPXULDmRTlGQJIlyWcIyLELfJeh1xHhhIxKj313Dd9fw3Da9TpteL8YyV2k2TLSmhWk41BbqWUJZlgXlchnLdIiThCiK8XyfnufheT5B0CfoZ/TDiKh/ibP2OpZpoWuWkKYpc1ndVChlQqtFkiSEYYjnefi+f0QQBIIkidkMz3Pe77Li6Bi6jda0M+HXCZ2WLYRxHAuJJxJ6h7J+JowTHl2LuD5wWG/rNJcNDM2m9lmoHAltyxaydGGWMEvZD3xCv4fXD/DihIP9q2xeNHAsHUMzaJkmp2unj1c+FJotoig6rJhV7XQ6uH6Me+4qP3c8LrbXePnbAb9eP4ehLbNiGTi2SS0Vfq6cnbKhW7gdl263S7u9RrfnMbh0ge27+9w+eMrjW3d4PBjw4Y8/ef3gDmeshkhnGumhHEuYXpuU5Z+aaE0DXTNZdRzu72zx6vkTng+f8fHTB96/+Yu3L4b88+4Nz3a3+cXVaTQ0UXt+vvZt5VKpJJicLCGVp5mpyMxUshbVapVqRWXmVIW5uVlURUaaLh1bM0lulG4kLBaLR6S/0ng+JZ/Nx/NiLhgfJ58vUCgUv1iTkw7TjYQTExP/i9xo70YXO315/Iuj5/8sVNQKKbJSQZJksQ8jvleWCv8FPDkFeMgsnqUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8882c29582df1429710fa93d7200b513/e4706/1440p_Settings_Tasks_Photoseries.avif 230w", "/de/static/8882c29582df1429710fa93d7200b513/d1af7/1440p_Settings_Tasks_Photoseries.avif 460w", "/de/static/8882c29582df1429710fa93d7200b513/7f308/1440p_Settings_Tasks_Photoseries.avif 920w", "/de/static/8882c29582df1429710fa93d7200b513/6f791/1440p_Settings_Tasks_Photoseries.avif 1296w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/8882c29582df1429710fa93d7200b513/a0b58/1440p_Settings_Tasks_Photoseries.webp 230w", "/de/static/8882c29582df1429710fa93d7200b513/bc10c/1440p_Settings_Tasks_Photoseries.webp 460w", "/de/static/8882c29582df1429710fa93d7200b513/966d8/1440p_Settings_Tasks_Photoseries.webp 920w", "/de/static/8882c29582df1429710fa93d7200b513/0b716/1440p_Settings_Tasks_Photoseries.webp 1296w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8882c29582df1429710fa93d7200b513/81c8e/1440p_Settings_Tasks_Photoseries.png 230w", "/de/static/8882c29582df1429710fa93d7200b513/08a84/1440p_Settings_Tasks_Photoseries.png 460w", "/de/static/8882c29582df1429710fa93d7200b513/c0255/1440p_Settings_Tasks_Photoseries.png 920w", "/de/static/8882c29582df1429710fa93d7200b513/86a1e/1440p_Settings_Tasks_Photoseries.png 1296w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/8882c29582df1429710fa93d7200b513/c0255/1440p_Settings_Tasks_Photoseries.png",
              "alt": "Web User Interface - 1440p Serie - Aufnahme Menu",
              "title": "Web User Interface - 1440p Serie - Aufnahme Menu",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <PhotoTable mdxType="PhotoTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/e2e58/1440p_Settings_Task_Photoseries_Shedule.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.60869565217391%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACoUlEQVQoz2WRXW/TZhiG8zMqbbBUSCROeoQEoQK6VGntOHGd2I6JHadu3Q8ga9rApq2N03xRKP0AJECCcoBaclQkpiENIfFd4ACJE37BfsuFkgIb7ODS9T6v9N66H72BgYEBBEFA8prIv3UYKd8lMbfF8C9bDJ270+Pn0rd074ZLt1H/6GAubPDTwR/o6+sjGAwSiEajhMNh9NIKxdYu+eoOVq1D3u9gVu9jVjvklna+Yny2ubTNeHuXzGwDIRRGELrFogQikQhdEvGTZNOjqHKiRzYtYqgy+liSXDbFpGPiFnLkMjKaIqIpEllFJC1KZDMukqgSOza43zAUCuEUizRbbZbrDWq1Gn51ieWaj19dpNmo02rWaTcbVBbmUccUdC2LpqnkxkxseQpFUhg8Hvt3ZUVR8DyPYtFhYqbE5HwNr+zjlatMfrY37zNeWiQ/XcGauYA5fYGpgsvVGYspN8XQqf8EyrKM4xTR1DTmuTrW+lvyq8+xVp+Rv/KyZ6s7r73CWXtBYWOP/Noes+eXudGeYNqNM3TyOIEvv5xKpXBdF1NXsebaFK697z1y1l9T2Hy77403FDbf4ay/orj5DmPlOcvXdvjw6B6VYpJY7Nh+Q0EIIyZTGNY4iprh9Nkq9srf2K0/sVsPsdt/7Z8bD7Dqu9iNXcyVRyi1B/irt/jnyWO2Fs5w9OiRbmCEUFggp4zy+7RO2c2QM3Q03fgOHd2ZxZhc4LQ9RUnT8VJjXPq1wse9p2z7c2RHYgQGohEOHY5QsRM8vpjh/qKCbWq9AMPQMXo20LUMZvkyeX+biTMNbslpbkoKl7wJHm5dp+3pmFLsy8oCJ4biDItp4iMykpQkmfw/0mgCKRFHFBMMJ5Mk0mlig4Mc/PEA/cF+gsF+PgGj6M1sUtEO9QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8023a8f760c6c6dc28005a9b8adf2d20/e4706/1440p_Settings_Task_Photoseries_Shedule.avif 230w", "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/d1af7/1440p_Settings_Task_Photoseries_Shedule.avif 460w", "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/7f308/1440p_Settings_Task_Photoseries_Shedule.avif 920w", "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/c986f/1440p_Settings_Task_Photoseries_Shedule.avif 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/8023a8f760c6c6dc28005a9b8adf2d20/a0b58/1440p_Settings_Task_Photoseries_Shedule.webp 230w", "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/bc10c/1440p_Settings_Task_Photoseries_Shedule.webp 460w", "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/966d8/1440p_Settings_Task_Photoseries_Shedule.webp 920w", "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/b8544/1440p_Settings_Task_Photoseries_Shedule.webp 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8023a8f760c6c6dc28005a9b8adf2d20/81c8e/1440p_Settings_Task_Photoseries_Shedule.png 230w", "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/08a84/1440p_Settings_Task_Photoseries_Shedule.png 460w", "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/c0255/1440p_Settings_Task_Photoseries_Shedule.png 920w", "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/e2e58/1440p_Settings_Task_Photoseries_Shedule.png 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/8023a8f760c6c6dc28005a9b8adf2d20/c0255/1440p_Settings_Task_Photoseries_Shedule.png",
              "alt": "Web User Interface - 1440p Serie - Aufnahme Menu",
              "title": "Web User Interface - 1440p Serie - Aufnahme Menu",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ScheduleTable mdxType="ScheduleTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      